import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";

@Injectable({ providedIn: "root" })
export class LoginValidationService {
  isEmail(value: string): boolean {
    return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value);
  }

  isMobile(value: string): boolean {
    return /^\d{10}$/.test(value);
  }

  isUsername(value: string): boolean {
    return /^[a-zA-Z0-9_-]+$/.test(value);
  }

  passwordValidator(control: AbstractControl): ValidationErrors | boolean {
    const value = control.value;
    if (!value) return false;

    // Regex: min 8 chars, 1 lowercase, 1 uppercase, 1 digit, 1 special char
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (!regex.test(value)) {
      return {
        passwordInvalid:
          "Password must be at least 8 characters, include at least 1 lowercase, 1 uppercase, 1 number, and 1 special character.",
      };
    }
    return true;
  }

  getType(value: string): "email" | "mobile" | "username" | "invalid" {
    if (this.isEmail(value)) return "email";
    if (this.isMobile(value)) return "mobile";
    if (this.isUsername(value)) return "username";
    return "invalid";
  }
}
